<template>

    <div ref="container" style="position:absolute;">
        <slot></slot>
    </div>


</template>

<script>

export default {

    props: {

        top: {
            type: Number,
            default: null,
        },
        bottom: {
            type: Number,
            default: null,
        },
        left: {
            type: Number,
            default: null,
        },
        right: {
            type: Number,
            default: null,
        },
    },

    data: function() {
        return {
            pos1: 0,
            pos2: 0,
            pos3: 0,
            pos4: 0,
        };

    },

    mounted() {

        this.container = this.$refs.container;

        if (this.top !== null) {
            this.container.style.top =  (this.top) + 'px';
        }

        if (this.bottom !== null) {
            this.container.style.bottom =  (this.bottom) + 'px';
        }

        if (this.left !== null) {
            this.container.style.left =  (this.left) + 'px';
        }

        // OMFG this has to be set with 'style.left' property since for some unexplained reason if set with 'style.right' property everything goes to hell
        if (this.right !== null) {
            let width = this.container.getBoundingClientRect().width;
            let left = document.body.clientWidth - width - this.right;
            this.container.style.left = left + 'px';
        }

        this.$nextTick(() => { // make sure inner html is rendered
             this.container.querySelectorAll('[drag-handle]').forEach(element => {
                element.onmousedown = this.dragMouseDown;
            });
        });

    },


    methods: {

        dragMouseDown: function(e) {

            e = e || window.event;
            e.preventDefault();

            // get the mouse cursor position at startup:
            this.pos3 = e.clientX;
            this.pos4 = e.clientY;

            document.onmouseup = this.closeDragElement;

            // call a function whenever the cursor moves:
            document.onmousemove = this.elementDrag;
        },

        elementDrag: function(e) {

            e = e || window.event;
            e.preventDefault();

            // calculate the new cursor position:
            this.pos1 = this.pos3 - e.clientX;
            this.pos2 = this.pos4 - e.clientY;
            this.pos3 = e.clientX;
            this.pos4 = e.clientY;

            // set the element's new position:
            this.container.style.top = (this.container.offsetTop - this.pos2) + 'px';
            this.container.style.left = (this.container.offsetLeft - this.pos1) + 'px';
        },

        closeDragElement: function() {

            /* stop moving when mouse button is released:*/
            document.onmouseup = null;
            document.onmousemove = null;
        },

    },


};
</script>
